export default __webpack_public_path__ + "static/media/zollaSL.6fa167d0.jpg";